import { createAsyncThunk } from "@reduxjs/toolkit";
import { deleteUserPermission, getPermissionListData, getPermissionsData, postPermission, postUserPermission } from "../../../helpers/backend_helper";
import { setPermissionTypes } from "./reducer";
import { filterPermissions } from "./helper.js";
import { inviteUserError } from "../settings/reducer.js";
import {checkMaintenance} from '../login/helper';

export const getPermissions = () => async (dispatch, getState) => {
  try {
    const response = await getPermissionsData();
    dispatch(setPermissionTypes(response.data));
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
  }
}

export const getPermissionList = createAsyncThunk("permission/getPermissionListData", async (data, { dispatch, getState }) => {
  try {
    const response = await getPermissionListData();
    if (response.status === 'ok') {
      return response.data;
    } else {
      throw response;
    }
    // response.data.markets['65cf1dc0362b2fac44cf95e7'].permissions[0].level = 1;
  } catch (error) {
    // console.log(error);
    checkMaintenance(dispatch, error);
    return error;
  }
});

export const getOtherUserPermission = createAsyncThunk("permission/getOtherUserPermission", async (id, { dispatch, getState }) => {
  const {language} = getState().MenuData;
  try {
    const menuData = getState().MenuData.client;
    const permissionList = getState().Permission.permissionTypes;
    const response = await postUserPermission({ id: id });
    let filteredPermission = [];
    if (response.status === 'ok') {
      if (response.data.length > 0) {
        let i = 0;
        do {
          let item = filterPermissions(menuData, permissionList, response.data[i]);
          filteredPermission.push(item);
          i++;
        } while (i < response.data.length);
      }
      if (filteredPermission.length > 0) {
        return filteredPermission;
      } else {
        return [];
      }
    } else {
      throw response;
    }
  } catch (error) {
    checkMaintenance(dispatch, error);
    dispatch(inviteUserError(language[error?.code]));
    return null;
  }
});

export const addPermission = (data) => async (dispatch, getState) => {
  try {
    const response = await postPermission(data);
    return response;
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
  }
}

export const removePermission = (id) => async (dispatch, getState) => {
  try {
    const response = await deleteUserPermission({ id: id });
    return response;
  } catch (error) {
    checkMaintenance(dispatch, error);
    // console.log(error);
  }
}